import { Popover, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import type { MenuProps } from 'antd';
import {
  greyColor, maxWidth, primaryColor, primaryFont, retina, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import {
  IsMobile, getSortingDefaultKey, getSortingLabel, valueToObject,
} from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { selectedSortingType } from 'Selector/CompaniesSelector';
import { actions as flurryActions } from 'Slice/HelperSlice';
import GlobalButton from './GlobalButton';
import DescendingIcon from '../assets/svgIcons/DescendingIcon';
import DownAngleIcon from '../assets/svgIcons/DownAngleIcon';
import AscendingIcon from '../assets/svgIcons/AscendingIcon';
import SortingByNameSvg from '../assets/svgIcons/SortingByNameSvg';
import SortingByDate from '../assets/svgIcons/SortingByDate';
import SortingByRevenueSvg from '../assets/svgIcons/SortingByRevenueSvg';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import FilterIcon from '../assets/svgIcons/FilterIcon';

const StyleWrapper = styled.div < { separatorColor?: string, buttonHeight?: string, iconModeBtnWidth?: string, buttonHeightSm?: string } >`
.sort-menu-popover {
  .ant-popover {
    &.ant-popover-placement-bottomLeft {
      padding-top: 0px !important;
    }
    &.ant-popover-placement-bottomRight {
      padding-top: 0px !important;
    }
    .ant-popover-content {
      .ant-popover-arrow {
        display: none;
      }
      .ant-popover-inner {
        border-radius: 8px;
        border: 1px solid #DADADA;
        background: #FFF;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
        width: fit-content;
        padding: 0px !important;
        .ant-popover-inner-content {
          width: unset !important;
          height: unset !important;
          padding: 0px !important;
          .menu-for-sorting {
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 215px !important;
            }
            &.ant-menu-vertical {
              border-right: 0px !important;
            }
            .ant-menu-submenu {
              &:nth-child(3) {
                .ant-menu-submenu-title {
                   svg {
                    margin-left: -1px;
                    min-width: 21px;
                   }
                }
              }
              &.ant-menu-submenu-active {
                background: #F1F1F1;
                .ant-menu-submenu-title {
                  &:active {
                    background: unset;
                  }
                  svg {
                    path {
                      fill: ${primaryColor};
                    }
                  }
                  .ant-menu-title-content {
                    color: ${primaryColor};
                  }
                }
              }
              &.ant-menu-submenu-vertical {
                border-right: 0px !important;
              }
              .ant-menu-submenu-title {
                &:hover {
                  background-color: unset !important;
                }
                display: flex;
                align-items: center;
                height: 32px;
                svg {
                  min-width: 20px;
                }
                .ant-menu-title-content {
                  margin-left: 6px;
                  color: ${greyColor};
                  font-family: ${primaryFont};
                  font-size: 16px;
                  font-weight: ${wMedium};
                  line-height: 20px;
                  letter-spacing: -0.4px;
                  @media all and (max-width: ${maxWidth}), ${retina} {
                    font-size: 14px;
                    line-height: 18px;
                  }
                }
                .down-angle-icon {
                  position: absolute;
                  right: 16px;
                  transform: rotate(269deg);
                }
              }
            }
          }
        }
      }
    }
   }
  }
.sort-by-btn {
  &.filterApplied {
    border: 1px solid ${primaryColor};
    background-color: rgb(222, 246, 230);
    color: ${primaryColor};
    .down-angle-icon {
      path {
        fill: ${primaryColor};
      }
    }
  }
  &.iconModeState {
    &.activeBtnState {
      background-color: #fff;
    }
    height: ${(props) => props.buttonHeight};
    width: ${(props) => props.iconModeBtnWidth};
    min-width: ${(props) => props.iconModeBtnWidth};
    padding: 6px;
    color: #fff;
    border: 0px;
    box-shadow: 0px 0px 18.1px 0px rgba(0, 0, 0, 0.15);
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: ${(props) => props.buttonHeightSm};
    }
    .filter-icon-dropdown {
      width: 20px;
      min-width: 25px;
      margin-right: 0px;
    }
    .separator-right {
      display: none;
    }
    .down-angle-icon {
      display: none;
    }
  }
  &.activeBtnState {
    .down-angle-icon {
      transform: rotate(180deg);
    }
  }
  margin-right: 8px !important;
  .filter-icon-dropdown {
    width: 15px;
    height: 14px;
    margin-right: 6px;
  }
  .separator-right {
    height: 17px;
    margin: 0px 5px 0px 10px;
    background-color: ${(props) => (props.separatorColor ? props.separatorColor : greyColor)};
  }
  .down-angle-icon {
    width: 8px;
    height: 6px;
  }
}
`;
const ContentWrapper = styled.div`
.reset-button {
  display: inline-flex;
  justify-content: flex-end;
  width: 100%;
  padding-right: 16px;
  padding-bottom: 10px;
  color: ${primaryColor};
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wMedium};
  line-height: 20px;
  letter-spacing: -0.4px;
  cursor: pointer;
}
`;
type Props = {
  buttonHeight?: string,
  buttonHeightSm?: string,
  separatorColor?: string,
  paddingXsm?: string,
  iconModeFlag?: boolean,
  iconModeBtnWidth?: string,
  setEditClicked?: (value: boolean) => void,
  setRemovedCompanies?: (value: []) => void
} & typeof defaultProps;

const defaultProps = {
  buttonHeight: '38px',
  buttonHeightSm: '32px',
  iconModeBtnWidth: '35px',
  paddingXsm: '8px',
  separatorColor: '32px',
  iconModeFlag: false,
  setEditClicked: () => { },
  setRemovedCompanies: () => { },
};
const FilterCompanySortBy = function FilterCompanySortBy(props: Props) {
  const {
    buttonHeight, buttonHeightSm, iconModeFlag, separatorColor,
    iconModeBtnWidth, paddingXsm, setEditClicked, setRemovedCompanies,
  } = props;
  const [open, setOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(['1']); // Default selected key
  const sortingType = useSelector(selectedSortingType);
  const dispatch = useDispatch();
  // const isTab = IsTablet();
  const isMob = IsMobile();
  const toggle = () => {
    if (!open) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_sortByButton_companyDashboard', 0),
      ));
    }
    setOpen(!open);
  };
  const handleChange = () => {
    toggle();
  };
  type MenuItem = Required<MenuProps>['items'][number] & { children?: MenuItem[] };

  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }
  const items: MenuItem[] = [
    getItem('Name', 'sub1', <SortingByNameSvg />, [
      getItem('A to Z', '1', <AscendingIcon />), getItem('Z to A', '2', <DescendingIcon />)]),
    getItem('Revenue', 'sub3', <SortingByRevenueSvg />, [
      getItem('Lowest first', '5', <AscendingIcon />), getItem('Highest first', '6', <DescendingIcon />)]),
    getItem('Date Followed', 'sub2', <SortingByDate />, [
      getItem('Newest first', '3', <AscendingIcon />), getItem('Oldest first', '4', <DescendingIcon />)]),
  ];
  const onClick: MenuProps['onClick'] = (e) => {
    const clickedItem = items.flatMap(
      (item) => (item?.children ? item?.children : item),
    ).find((item) => item?.key === e.key);
    setEditClicked();
    toggle();
    setRemovedCompanies();
    dispatch(companiesActions.resetCompareCompaniesIds());
    setSelectedKeys([e.key]);
    if (clickedItem) {
      const label = getSortingLabel(e.key);
      dispatch(companiesActions.setSortingType(label));
    }
  };

  useEffect(() => {
    const key = getSortingDefaultKey(sortingType);
    setSelectedKeys([key]);
  }, [sortingType]);

  const onOpenChange = () => {
    setOpenSubMenu(!openSubMenu);
  };
  useEffect(() => {
    const node = document.querySelector('.ant-menu-submenu-popup');

    return node?.classList.add('sub-menu-for-sorting');
  }, [openSubMenu]);
  const resetSort = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('click_resetSort_companyDashboard', 0),
    ));
    dispatch(companiesActions.setSortingType(''));
    dispatch(companiesActions.resetCompareCompaniesIds());
    setSelectedKeys(['0']);
    toggle();
    setEditClicked();
  };

  const content = (
    <ContentWrapper>
      <Menu
        onClick={onClick}
        style={{ width: isMob ? 230 : 274, borderRadius: 8 }}
        mode="vertical"
        items={items}
        expandIcon={<DownAngleIcon color="rgba(126, 126, 126, 1)" />}
        className="menu-for-sorting"
        onOpenChange={onOpenChange}
        selectedKeys={selectedKeys}
      />
      <span
        className="reset-button"
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            resetSort();
          }
        }}
        onClick={resetSort}
        onKeyDown={(e) => {
          if (e.key === ' ') {
            e.preventDefault();
          }
        }}
      >
        Reset
      </span>
    </ContentWrapper>
  );
  return (
    <StyleWrapper
      separatorColor={separatorColor}
      buttonHeight={buttonHeight}
      buttonHeightSm={buttonHeightSm}
      iconModeBtnWidth={iconModeBtnWidth}
    >
      <Popover
        placement="bottomLeft"
        content={content}
        trigger="click"
        open={open}
        onOpenChange={handleChange}
        getPopupContainer={(e: HTMLElement) => e}
        className="sort-menu-popover"
        arrow={false}
      >
        <div
          aria-hidden="true"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <GlobalButton
            IconLeft={(
              <FilterIcon color={(open || sortingType)
                ? primaryColor : greyColor}
              />
            )}
            title="Filter"
            outlineColor={open ? primaryColor : 'rgba(218, 218, 218, 1)'}
            textColor={open ? primaryColor : 'rgba(126, 126, 126, 1)'}
            bgColor={open ? '#eaf9ee' : '#fff'}
            PaddingSm="8px 10px 8px 13px"
            innerSpace="8px 10px 8px 13px"
            heightSm={buttonHeightSm}
            height={buttonHeight}
            onButtonClick={() => { }}
            RightSeparator
            IconRight={<DownAngleIcon color={open ? primaryColor : 'rgba(126, 126, 126, 1)'} />}
            disabled={false}
            buttonClassName={classNames('sort-by-btn', { activeBtnState: open, iconModeState: iconModeFlag, filterApplied: sortingType !== '' })}
            LeftSpace="0px !important"
            borderWidth="1px"
            PaddingXsm={paddingXsm}
          />
        </div>
      </Popover>
    </StyleWrapper>
  );
};
FilterCompanySortBy.defaultProps = defaultProps;
export default FilterCompanySortBy;
